import i18n from "i18next";

const validate = (values: any) => {
	const errors: any = {};
	if (!values.fullName) {
		errors.fullName = i18n.t("required");
	}
	if (!values.mobilePhone) {
		errors.mobilePhone = i18n.t("required");
	}
	if (!values.email || /^\s*$/.test(values.email)) {
		errors.email = i18n.t("required");
	} else if (!/\S+@\S+\.\S+/.test(values.email)) {
		errors.email = "Email address is invalid";
	}
	return errors;
};

export default validate;
